<template>
  <v-app id="khimza">
    <v-navigation-drawer :clipped="$vuetify.breakpoint.lgAndUp" v-model="drawer" v-if="login" fixed app>
      <v-list dense>
        <template v-for="item in itemsMenu[menuSup]">
          <v-layout v-if="item.heading" :key="item.heading" row align-center>
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group v-else-if="item.children" v-model="item.model" :key="item.text" :prepend-icon="item.model ? item.icon : item['icon-alt']" append-icon="">
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile v-for="(child, i) in item.children" :key="i">
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ child.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :key="`item-${item.text}`" :to="item.url">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar :clipped-left="$vuetify.breakpoint.lgAndUp" color="blue darken-3" v-if="login" dark app fixed>
      <v-toolbar-title style="width: 300px" class="ml-0">
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <span class="hidden-sm-and-down">{{ empresa }}</span>
      </v-toolbar-title>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn flat :disabled="menuSup === 'Ventas'" @click="seleccionarMenuSup('Ventas')">Ventas</v-btn>
        <v-btn flat :disabled="menuSup === 'Almacén'" @click="seleccionarMenuSup('Almacén')">Almacén</v-btn>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>notifications</v-icon>
      </v-btn>
      <div class="v-toolbar__items">
        <v-menu offset-y>
          <v-btn slot="activator" class="v-btn--flat">
            <span><v-icon>home</v-icon></span> <span>{{ local }}</span>
          </v-btn>
          <v-list>
            <v-list-tile v-for="(item, index) in locales" :key="index" @click="setLocal(item.nombre)">
              <v-list-tile-title>{{ item.nombre }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
      <div class="v-toolbar__items">
        <v-menu offset-y>
          <v-btn slot="activator" class="v-btn--flat">
            <span><v-icon>account_circle</v-icon></span> <span>{{ usuario }}</span>
          </v-btn>
          <v-list>
            <v-list-tile @click.stop="cambiarClave.open = true">
              <v-list-tile-title>Cambiar clave</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="cerrarSesion()">
              <v-list-tile-title>Cerrar sesión</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
    </v-toolbar>
    <v-content v-if="login">
      <v-alert v-if="versionCli !== versionSer" :value="true" type="warning">Hay una nueva versión disponible. Presione F5 para actualizar.</v-alert>
      <v-alert v-if="entorno === 'development'" :value="true" type="warning">Entorno de desarrollo</v-alert>
      <v-container fluid fill-height>
          <v-layout justify-center>
              <main>
                <router-view v-on:login="loginOff" v-bind:ubigeo="ubigeo"></router-view>
              </main>
          </v-layout>
      </v-container>
    </v-content>
    <cambiar-clave v-bind:cambiarClave="cambiarClave"></cambiar-clave>
    <login v-bind:login="loginForm" v-on:set-token="setToken" v-bind:msgError="this.loginMsg"></login>
  </v-app>
</template>

<script>
  import mixin from './mixins.js'
  export default {
    name: 'app',
    mixins: [mixin],
    data: () => ({
      versionCli: '1.0.36',
      versionSer: '',
      tokenId: '',
      login: false,
      loginForm: {open: false},
      loginMsg: '',
      cambiarClave: {open: false},
      drawer: null,
      entorno: '',
      menuSup: 'Ventas',
      itemsMenu: {
        Ventas: [
          { icon: 'person', text: 'Clientes', url: '/clientes' },
          { icon: 'store', text: 'Ventas', url: '/ventas' },
          { icon: 'local_shipping', text: 'Guía de remisión', url: '/guias' },
          { icon: 'shopping_cart', text: 'Compras', url: '/compras' },
          { icon: 'account_balance', text: 'Depósitos', url: '/depositos' },
          { icon: 'print', text: 'Reportes', url: '/reportes' }
        ],
        Almacén: [
          { icon: 'assignment', text: 'Catálogo', url: '/catalogo' },
          { icon: 'add_circle', text: 'Ingresos', url: '/ingresos' },
          { icon: 'remove_circle', text: 'Salidas', url: '/salidas' }
        ]
      },
      ubigeo: [],
      locales: [],
      local: '',
      empresa: '',
      usuario: ''
    }),
    props: {
      source: String
    },
    beforeMount () {
      this.entorno = process.env.NODE_ENV
      this.tokenId = localStorage.getItem('ventasTokenId')
      this.local = localStorage.getItem('ventasLocal')
      if (this.$router.currentRoute.name === 'Catalogo') {
        this.menuSup = 'Almacén'
      }
      this.variablesApp()
    },
    watch: {
      tokenId (val) {
        localStorage.setItem('ventasTokenId', val)
      },
      local (val) {
        localStorage.setItem('ventasLocal', val)
        if (val === 'undefined') {
          localStorage.setItem('ventasLocal', '')
        }
      },
      login (val) {
        if (val === false) {
          this.loginForm.open = true
        }
      }
    },
    methods: {
      variablesApp () {
        var solicitudApi = this.crearSolicitud()
        var vueThis = this
        const myRequest = new Request(`${process.env.NODE_API}inicio/variablesApp`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
        this.loading = true
        return fetch(
          myRequest
        )
          .then(response => response.json())
          .then(datos => {
            if (datos.l === false) {
              vueThis.loginOff([''])
            } else {
              vueThis.login = datos.l
              vueThis.versionSer = datos.d.version
              vueThis.empresa = datos.d.empresa
              vueThis.usuario = datos.d.usuario
              vueThis.locales = datos.d.locales
              vueThis.local = datos.d.local
              vueThis.ubigeo = datos.d.ubigeo
              localStorage.setItem('ventasVars', btoa(JSON.stringify(datos)))
            }
          }).catch(function () {
            var datos = JSON.parse(atob(localStorage.getItem('ventasVars')))
            if (datos.l === false) {
              vueThis.loginOff([''])
            } else {
              vueThis.login = datos.l
              vueThis.empresa = datos.d.empresa
              vueThis.usuario = datos.d.usuario
              vueThis.locales = datos.d.locales
              vueThis.local = datos.d.local
              vueThis.ubigeo = datos.d.ubigeo
            }
          })
      },
      setToken (token) {
        this.tokenId = token
        this.login = true
        localStorage.setItem('ventasTokenId', token)
        this.variablesApp()
      },
      setLocal (local) {
        for (var buscar in this.locales) {
          if (this.locales[buscar].nombre === local) {
            localStorage.setItem('ventasLocal', local)
            this.local = local
            this.$router.push('/')
            this.variablesApp()
            return
          }
        }
        localStorage.setItem('ventasLocal', this.local)
        this.$router.push('/')
      },
      loginOff (msg) {
        this.login = false
        if (0 in msg) {
          this.loginMsg = msg[0]
        } else {
          this.loginMsg = msg
        }
        this.loginForm.open = true
      },
      cerrarSesion () {
        localStorage.setItem('ventasTokenId', '')
        localStorage.setItem('ventasLocal', '')
        this.login = false
      },
      seleccionarMenuSup (menu) {
        this.menuSup = menu
        this.$router.push('/')
      }
    }
  }
</script>

<style>
body {
  margin: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

main {
  width: 98%
}

.v-toolbar__content, .v-toolbar__extension {
    padding: 0 4px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue